const THREE = require('three')
import raf from 'src/components/game/raf'
import _ from 'lodash'
import {TimelineMax, TweenMax, Cubic} from 'gsap'
import {config as gameConfig} from '../../config'

// *****************************************************************
//
// FOREGROUND
//
// *****************************************************************
let geometry = new THREE.PlaneBufferGeometry( 128, 128, 1 )
let canvas = document.createElement('canvas')
canvas.width = 128
canvas.height = 128
let ctx = canvas.getContext('2d')
let texture = new THREE.Texture(canvas)
let material = new THREE.MeshBasicMaterial({
  map: texture,
  transparent: true
})
material.depthTest = false
material.depthWrite = false

export let mesh = new THREE.Mesh(geometry, material)
mesh.name = 'dashboard-counter'
mesh.material.opacity = 0
mesh.scale.setScalar(0.35)
export default mesh


// *****************************************************************
//
// DRAW
//
// *****************************************************************
let fontSize = 93
let fontColor = '#FFFFFF'
ctx.font = `${fontSize}px digital`
ctx.fillStyle = fontColor

let draw = function (string) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  if (parseInt(string) <= 9) string = ` ${string}`
  ctx.fillText(string, 0, fontSize)
  texture.needsUpdate = true
}


// *****************************************************************
//
// UPDATE
//
// *****************************************************************
const update = _.throttle(()=> {
  let vel = window.game.state.velocity.now || 0
  draw(Math.round(vel / 3))
}, gameConfig.uiUpdateInterval)
// raf.on('tick', update)
setInterval(update, gameConfig.uiUpdateInterval)


export let start = (seconds) => {
  let tl = new TimelineMax()
  tl.to(mesh.material, seconds, {opacity: 1, ease: Cubic.easeInOut})
}

export let reset = (seconds) => {
  mesh.material.opacity = 0
}




// WEBPACK FOOTER //
// ./src/components/game/ui/dashboard/counterFg.js